'use strict';

var ROMSummaryTopOppGridFilterFactory = function ROMSummaryTopOppGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMSummaryTopOppGridFilter() {
    DemandFilter.call(this, ['rom-summary-top-opp-spill-mode', 'rom-summary-top-opp-recap-mode'], ['rom-summary-top-spill', 'rom-summary-top-recap']);
    this.registerFilters(injectedFilters);
  }
  ROMSummaryTopOppGridFilter.constructor = ROMSummaryTopOppGridFilter;
  ROMSummaryTopOppGridFilter.prototype = Object.create(DemandFilter.prototype);
  ROMSummaryTopOppGridFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMSummaryTopOppGridFilter;
};
ROMSummaryTopOppGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMSummaryTopOppGridFilterFactory;